// 导出视图
import * as AuthView from './Auth/index';
import * as CommonView from './Common/index';
import * as AdminView from './Admin/index';
import * as PublicView from './Public/index';


// 导出路由
import Auth from './Auth/index';
import Common from './Common/index';
import Admin from './Admin/index';
import Public from './Public/index';

/** note: submenu only apppear when children.length>=1
 *   detail see  https://panjiachen.github.io/vue-element-admin-site/#/router-and-nav?id=sidebar
 **/

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']     will control the page roles (you can set multiple roles)
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
    noCache: true                if true ,the page will no be cached(default is false)
  }
 **/
export const constantRouterMap = {
  Common,
  Auth,
  Public
};

export const asyncRouterMap = {
  Admin,
};

export default {
  ...AuthView,
  ...CommonView,
  ...AdminView,
  ...PublicView,
}



// WEBPACK FOOTER //
// ./src/views/index.js